import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { DeviceTask } from '@era/device-task-management-sdk';
import { DeviceScheduledTasksComponent } from './device-scheduled-tasks.component';
import { AsyncPipe } from '@angular/common';
import {
  DeviceScheduledTasksStoreActions,
  DeviceScheduledTasksStoreSelectors,
} from '../../sub-features/device-sync/device-scheduled-tasks-store';

@Component({
  selector: 'era-device-scheduled-tasks',
  templateUrl: './device-scheduled-tasks.container.html',
  styleUrls: ['./device-scheduled-tasks.container.scss'],
  imports: [DeviceScheduledTasksComponent, AsyncPipe],
})
export class DeviceScheduledTasksContainerComponent {
  public readonly scheduledTasks$: Observable<DeviceTask[]>;

  constructor(private readonly store: Store<DeviceTask>) {
    this.scheduledTasks$ = this.store.select(DeviceScheduledTasksStoreSelectors.selectScheduledTasksByUdid);
  }

  public delete(event: DeviceTask): void {
    this.store.dispatch(
      DeviceScheduledTasksStoreActions.DeviceScheduledTasksUiActions.scheduledTaskDeleted({ deviceTask: event })
    );
  }
}
